import {
  Button,
  Container,
  Fab,
  makeStyles,
  Modal,
  Snackbar,
  Tooltip,
} from "@material-ui/core";
import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { Add as AddIcon } from "@material-ui/icons";

import $ from "jquery";
import SellingService from "../services/SellingService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
// import update from "immutability-helper";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 200,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));
$(".custom-file-input").on("change", function () {
  var fileName = $(this).val().split("\\").pop();
  $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
});
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UploadBcSellFile = ({
  setOnUploadFile,
  setInConfirmedBdc,
  setBDCRelatedToInvoice,
  bdcUploadInformation,
  setArchivedBdc,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [bDCImageFile, setBDCImageFile] = useState([]);

  $(".custom-file-input").on("change", function () {
    var fileNameTwo = $(this).val().split("\\").pop();
    $(this)
      .siblings(".custom-file-label")
      .addClass("selected")
      .html(fileNameTwo);
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  
  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnUploadFile(false);
  };

  const onUploadFileToBackendHandler = () => {
    if (bDCImageFile.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :aucun fichier ");
    } else {
      console.log(bdcUploadInformation);
      const uploadData = new FormData();
      uploadData.append("picture", bDCImageFile);

      SellingService.uploadFile("/uploadFile/BonCommandeSale", uploadData)
        .then((response) => {
          console.log("bdfile", response);
          if (Object.keys(response.data)[0] === "success") {
            onAddFileToBDCDocumentInDB(
              bdcUploadInformation.state,
              bdcUploadInformation.reference,
              response.data.success
            );
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText(
            "Erreur : erreur lors de l'enregistrment du fichier"
          );
        });

      setTimeout(setOnUploadFile(false), 5000);
      setOnUploadFile(false);
    }
  };

  const onUploadLocalFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setBDCImageFile(e.target.files[0]);
    }
  };

  const onAddFileToBDCDocumentInDB = (state, reference, path) => {
    console.log("updateBDCPathFile");

    SellingService.updateBDCPathFile(getCurrentUserId(), reference, path)
      .then((response) => {
        console.log("updateBDCPathFile", response);
        if (Object.keys(response.data)[0] === "success") {
          window.location.reload(false);

          if (bdcUploadInformation.isDeleted === 0) {
            if (state === 0) {
              let newState = bdcUploadInformation.bdcData.filter(
                (item) => item.reference !== reference
              );

              let new_array = add_items_to_array_at_position(
                newState,
                bdcUploadInformation.index,
                [response.data.success]
              );
              // console.log(new_array);

              setInConfirmedBdc(new_array);
            } else if (state === 2) {
              // let newState = bdcUploadInformation.bdcData.filter(
              //   (item) => item.reference !== reference
              // );
              // console.log(typeof path);

              // let new_array = add_items_to_array_at_position(
              //   newState,
              //   bdcUploadInformation.index,
              //   [response.data.success]
              // );
              // console.log(new_array);
            } else if (state === 1) {
              let newState = bdcUploadInformation.bdcData.filter(
                (item) => item.reference !== reference
              );
              // console.log(typeof path);

              let new_array = add_items_to_array_at_position(
                newState,
                bdcUploadInformation.index,
                [response.data.success]
              );
              // console.log(new_array);

              setBDCRelatedToInvoice(new_array);
            }
          } else {
            let newState = bdcUploadInformation.bdcData.filter(
              (item) => item.reference !== reference
            );
            // console.log(typeof path);

            let new_array = add_items_to_array_at_position(
              newState,
              bdcUploadInformation.index,
              [response.data.success]
            );

            setArchivedBdc(new_array);
          }
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  function add_items_to_array_at_position(array, index, new_items) {
    return [...array.slice(0, index), ...new_items, ...array.slice(index)];
  }

  return (
    <>
      <Tooltip title="Add" aria-label="add" onClick={() => setOpen(true)}>
        <Fab color="primary" className={classes.fab}>
          <AddIcon />
        </Fab>
      </Tooltip>
      <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <label for="exampleInputFile10">Bon de commande </label>
              <div class="input-group">
                <div class="custom-file">
                  <input
                    accept="application/pdf"
                    type="file"
                    className="custom-file-input"
                    id="exampleInputFile10"
                    onChange={onUploadLocalFileHandler}
                  />
                  <label class="custom-file-label" for="exampleInputFile10">
                    Entrer le fichier de BDC
                  </label>
                </div>
              </div>
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onUploadFileToBackendHandler}
              >
                Ajouter
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Quitter
              </Button>
            </div>
          </form>
        </Container>
      </Modal>
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UploadBcSellFile;
